import { Button } from "@/lib/components/Button/Button";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { IconVolume, IconVolumeOff } from "@tabler/icons-react";

export default function VideoPreviewMute() {
  const playerRef = useEditorStore((state) => state.service.getPlayerRef());
  const isMuted = useEditorStore((state) => state.videoPreviewState.isMuted);

  const toggleMute = () => {
    const player = playerRef?.current;

    if (!player) {
      return;
    }

    if (player.isMuted()) {
      player.unmute();
    } else {
      player.mute();
    }
  };

  return (
    <Button
      variant="ghost"
      size="iconSm"
      onClick={toggleMute}
      className="text-text-primary [&_svg]:size-5"
    >
      {isMuted ? <IconVolumeOff /> : <IconVolume />}
    </Button>
  );
}
